import { render } from "./MainSidebar.vue?vue&type=template&id=d43e0d7c&scoped=true"
import script from "./MainSidebar.vue?vue&type=script&lang=js"
export * from "./MainSidebar.vue?vue&type=script&lang=js"

import "./MainSidebar.vue?vue&type=style&index=0&id=d43e0d7c&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d43e0d7c"]])

export default __exports__